import { Suspense } from 'react'
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { AuthLayout as AuthLayoutComponent } from '@/layouts'
import { RouteLoadingFallback } from '@/components/loading/RouteLoadingFallback'

/**
 * Auth Layout Route (Pathless)
 *
 * Routes under this layout:
 * - / (Home)
 * - /dashboard
 * - /employees
 * - /workforce
 * - /vacation
 * - /calendar
 * - /training
 * - /performance
 * - All other authenticated routes
 *
 * The underscore prefix makes this route pathless - it provides layout
 * without contributing to the URL structure.
 *
 * Layout includes:
 * - Header (top bar) with user menu and navigation controls
 * - Sidebar (desktop) with application navigation
 * - Mobile sidebar drawer
 * - Main content area with responsive padding
 */
export const Route = createFileRoute('/_auth')({
  beforeLoad: async ({ location }) => {
    // Check if user is authenticated by looking at localStorage
    // This is a simple check - the AuthProvider will handle the full auth flow
    const storedUserProfile = localStorage.getItem('user-profile')

    console.log('🔒 _auth beforeLoad check:', {
      pathname: location.pathname,
      hasUserProfile: !!storedUserProfile
    })

    if (!storedUserProfile) {
      console.log('❌ No user profile, redirecting to login')
      throw redirect({
        to: '/login',
      })
    }
    
    console.log('✅ User authenticated, proceeding')
  },
  component: AuthLayout,
})

function AuthLayout() {
  return (
    <AuthLayoutComponent>
      <Suspense fallback={<RouteLoadingFallback />}>
        <Outlet />
      </Suspense>
    </AuthLayoutComponent>
  )
}
